// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zi-U","content":"styles_content__3D_on","tableWrap":"styles_tableWrap__1MIjY"};